var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{'btn-disabled': _vm.disabled, 'btn-big': _vm.big},on:{"click":_vm.buttonPressedEvent}},[_c('img',{class:{'btn-big-img': _vm.big, 'black': _vm.black},attrs:{"src":_vm.icon}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-91f99ff8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CircleButtonWithNamedEvent.vue
// module id = null
// module chunks = 